module.exports = __webpack_public_path__ + "img/circle-location-arrow.408a6971.svg";